import type { IconNames } from 'atoms/Icon'
import type { NavTabIconSize } from 'atoms/NavTab'
import type { IDropdownItemNavBarProps } from '../../DropdownItems/DropdownItemTypeButton/Templates'
import type { IDropdownHeaderProps } from '../DropdownHeader'

import { Icon, IconSizes } from 'atoms/Icon'
import { DropdownHeaderJustifyContent } from '../../DropdownHeader'
import { DropdownItemNavBar } from '../../DropdownItems/DropdownItemTypeButton/Templates'
import { DropdownHeader } from '../DropdownHeader'

export interface IDropdownHeaderNavBarProps extends Omit<
  IDropdownHeaderProps,
  'children'
> {
  title?: IDropdownItemNavBarProps['title']
  icon?: IconNames
  iconSize?: NavTabIconSize
}

export const DropdownHeaderNavBar = ({
  title = '',
  width,
  height,
  icon,
  iconSize,
  justifyContent = DropdownHeaderJustifyContent.FlexStart,
  ...rest
}: IDropdownHeaderNavBarProps) => (
  <DropdownHeader
    justifyContent={justifyContent}
    width={width}
    height={height}
    {...rest}
  >
    {icon && <Icon name={icon} size={iconSize ? IconSizes[iconSize] : null} />}
    {title && <DropdownItemNavBar title={title} />}
  </DropdownHeader>
)
